var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Inject, Prop, Watch } from 'vue-property-decorator';
var InputSource = (function (_super) {
    __extends(InputSource, _super);
    function InputSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InputSource.prototype.customURL = function (value) {
        return !!value.match(/youtube.*\b[\w\-]{11}\b|myouseek/) || 'Make sure you use youtube video link';
    };
    ;
    InputSource.prototype.validate = function () {
        var _this = this;
        setTimeout(function () {
            _this.$validator.validate("source");
        }, 0);
    };
    InputSource.prototype.onValueChanged = function (val) {
        var _this = this;
        var matches = val.match(/youtube.*\b([\w\-]{11}\b)/);
        if (matches) {
            var youtubeApiKey = "AIzaSyCO7KyCr8JB_UEDQPfq197nogWL_PgRdqs";
            var url = "https://www.googleapis.com/youtube/v3/videos?id=" + matches[1] + "&key=" + youtubeApiKey + "&fields=items(snippet(title))&part=snippet";
            var request_1 = new XMLHttpRequest();
            request_1.onreadystatechange = function () {
                if (request_1.readyState === 4) {
                    if (request_1.status === 200) {
                        _this.$emit("linked", JSON.parse(request_1.response)["items"][0].snippet.title);
                    }
                }
            };
            request_1.open("GET", url, true);
            request_1.send(null);
        }
    };
    __decorate([
        Inject("$validator"),
        __metadata("design:type", Object)
    ], InputSource.prototype, "$validator", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], InputSource.prototype, "value", void 0);
    __decorate([
        Watch("value", { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], InputSource.prototype, "onValueChanged", null);
    InputSource = __decorate([
        Component
    ], InputSource);
    return InputSource;
}(Vue));
export default InputSource;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/Inputs/InputTrackSource.vue
// module id = 221
// module chunks = 0